import { render, staticRenderFns } from "./DeleRegister.vue?vue&type=template&id=62334b3b&"
import script from "./DeleRegister.vue?vue&type=script&lang=js&"
export * from "./DeleRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports